const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/525614025070?text=Hola,%20me%20gustaría%20obtener%20más%20información%20sobre%20sus%20servicios"
      target="_blank"
      rel="nofollow noopener noreferrer"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 bg-green-500 hover:bg-green-600 rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 hover:scale-110 group"
      aria-label="Contactar por WhatsApp"
    >
      <i className="ri-whatsapp-fill text-white text-3xl"></i>
      <span className="absolute right-16 bg-gray-900 text-white px-4 py-2 rounded-lg text-sm font-body whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        ¿Necesitas ayuda?
      </span>
    </a>
  );
};

export default WhatsAppButton;